// SPDX-License-Identifier: AGPL-3.0-or-later
import {decompressZstdFrame} from '@app/features/platform/utils/LibFluxcore';
export type CompressionType = 'none' | 'zstd-stream';
export class GatewayCompression {
	private readonly type: CompressionType;
	constructor(type: CompressionType) {
		this.type = type;
	}
	async decompress(data: ArrayBuffer): Promise<string> {
		const input = new Uint8Array(data);
		switch (this.type) {
			case 'none':
				return new TextDecoder().decode(input);
			case 'zstd-stream':
				return this.decompressZstd(input);
			default:
				throw new Error(`Unsupported compression type: ${this.type}`);
		}
	}
	private async decompressZstd(data: Uint8Array): Promise<string> {
		const wasmDecoded = await decompressZstdFrame(data);
		if (!wasmDecoded) {
			throw new Error('Gateway zstd WASM not available');
		}
		const decompressed = wasmDecoded;
		return new TextDecoder().decode(decompressed);
	}
	destroy(): void {}
}
export function getPreferredCompression(): CompressionType {
	return 'zstd-stream';
}
export function isCompressionSupported(type: CompressionType): boolean {
	switch (type) {
		case 'none':
		case 'zstd-stream':
			return true;
		default:
			return false;
	}
}
